import { hasMultipleUnits } from '@/utils/unitUtils'

/**
 * Service for checking and managing product characteristics
 */
export const productCharacteristicsService = {
  /**
   * Checks whether a product has characteristics that need to be selected
   * @param {Object} product - The product object to be checked
   * @returns {Boolean} - Returns true if the product has characteristics, false otherwise
   */
  hasCharacteristics(product) {
    if (!product) {
      return false;
    }

    // Checks whether the product has at least one characteristic with values
    const hasProductCharacteristics = product.characteristics && (
      (product.characteristics.COLOR && product.characteristics.COLOR.length > 0) ||
      (product.characteristics.SIZE && product.characteristics.SIZE.length > 0) ||
      (product.characteristics.WEIGHT && product.characteristics.WEIGHT.length > 0)
    );

    // Checks whether the product has multiple units of measure
    const hasMultipleUnitsOfMeasure = hasMultipleUnits(product.unit_of_measure);

    return hasProductCharacteristics || hasMultipleUnitsOfMeasure;
  },

  /**
   * Checks whether all required characteristics have been selected
   * @param {Object} product - The product object
   * @param {Object} selectedCharacteristics - Object with the selected characteristics
   * @returns {Boolean} - Returns true if all required characteristics have been selected
   */
  allCharacteristicsSelected(product, selectedCharacteristics) {
    if (!product) {
      return true;
    }

    const { color, size, weight, unit } = selectedCharacteristics;

    // Checks whether all available characteristics have been selected
    if (product.characteristics?.COLOR?.length > 0 && !color) {
      return false;
    }

    if (product.characteristics?.SIZE?.length > 0 && !size) {
      return false;
    }

    if (product.characteristics?.WEIGHT?.length > 0 && !weight) {
      return false;
    }

    // Checks whether there are multiple units of measure and whether one has been selected
    if (hasMultipleUnits(product.unit_of_measure) && !unit) {
      return false;
    }

    return true;
  }
};
